import { type MaybePromise, noop } from '@amazon/vinyl-util'
import { prefersReducedMotion } from '@/util/reducedMotion'
import { clearPreparedViewTransitions } from './transitionKeys'

export function startViewTransition(cb: () => MaybePromise<unknown>): Promise<void> {
    const bodyClassList = document.body.classList
    bodyClassList.add('pageTransitionActive')

    if ('startViewTransition' in document && !prefersReducedMotion()) {
        const transition = document.startViewTransition(cb)
        // Safari will have an unhandled rejection if the transition
        // is aborted. Add a catch to ready.
        transition.ready.catch(noop)
        // Strip spent shared-element names once the morph settles (or aborts)
        // so they can't linger into an unrelated later transition.
        return transition.finished.finally(() => {
            clearPreparedViewTransitions()
            bodyClassList.remove('pageTransitionActive')
        })
    } else {
        // Propagate `cb`'s own outcome (not a detached `Promise.resolve()`) so
        // a caller's `.catch()` — e.g. the router's per-navigation error
        // handler — sees a rejection here exactly as it would via the
        // `transition.finished` path above, instead of it escaping as an
        // unhandled rejection on browsers without View Transitions support.
        return Promise.resolve(cb())
            .then(() => {})
            .finally(() => {
                bodyClassList.remove('pageTransitionActive')
                clearPreparedViewTransitions()
            })
    }
}
